import React from 'react';
import { createBingMap } from 'components/util';

export interface GpsddContentProps {
  position: string[];
  label?: string;
  className?: string;
  onClick?: () => void;
}

export class GpsddContent extends React.PureComponent<GpsddContentProps> {
  private mapRef: React.RefObject<HTMLDivElement>;

  constructor(props) {
    super(props);
    this.mapRef = React.createRef<HTMLDivElement>();
  }

  componentDidMount(): void {
    const isSmallFormFactor = (this.mapRef.current && this.mapRef.current.clientWidth < 500) || false;
    this.mapRef && createBingMap(this.props.position, 14, this.mapRef, this.props.label || '', isSmallFormFactor);
  }

  render(): JSX.Element {
    return (
      <div className={`h-100 w-100 ${this.props.className || ''}`} ref={this.mapRef} onClick={this.props.onClick} />
    );
  }
}

export default GpsddContent;
